function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/strikethrough/strikethroughediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AttributeCommand from '../attributecommand';
var STRIKETHROUGH = 'strikethrough';
/**
 * The strikethrough editing feature.
 *
 * It registers the `'strikethrough'` command, the <kbd>Ctrl+Shift+X</kbd> keystroke and introduces the
 * `strikethroughsthrough` attribute in the model which renders to the view
 * as a `<s>` element.
 *
 * @extends module:core/plugin~Plugin
 */

var StrikethroughEditing =
/*#__PURE__*/
function (_Plugin) {
  _inherits(StrikethroughEditing, _Plugin);

  function StrikethroughEditing() {
    _classCallCheck(this, StrikethroughEditing);

    return _possibleConstructorReturn(this, _getPrototypeOf(StrikethroughEditing).apply(this, arguments));
  }

  _createClass(StrikethroughEditing, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var editor = this.editor; // Allow strikethrough attribute on text nodes.

      editor.model.schema.extend('$text', {
        allowAttributes: STRIKETHROUGH
      });
      editor.model.schema.setAttributeProperties(STRIKETHROUGH, {
        isFormatting: true,
        copyOnEnter: true
      });
      editor.conversion.attributeToElement({
        model: STRIKETHROUGH,
        view: 's',
        upcastAlso: ['del', 'strike', {
          styles: {
            'text-decoration': 'line-through'
          }
        }]
      }); // Create strikethrough command.

      editor.commands.add(STRIKETHROUGH, new AttributeCommand(editor, STRIKETHROUGH)); // Set the Ctrl+Shift+X keystroke.

      editor.keystrokes.set('CTRL+SHIFT+X', 'strikethrough');
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'StrikethroughEditing';
    }
  }]);

  return StrikethroughEditing;
}(Plugin);

export { StrikethroughEditing as default };